import { Card, CardContent } from '@/components/ui/card'
import { ChevronRight } from 'lucide-react'
import { Link } from 'react-router-dom'
import { type ElfRace } from '@/client/lib/elves'

const races: { name: ElfRace; slug: string; icon: string; description: string }[] = [
  { name: 'High Elf', slug: 'high-elf', icon: '🧝', description: 'Noble, magical, and ancient.' },
  { name: 'Dark Elf', slug: 'dark-elf', icon: '🌑', description: 'Mysterious, devious, and subterranean.' },
  { name: 'Wood Elf', slug: 'wood-elf', icon: '🌲', description: 'Wild, fast, and nature-bound.' },
  { name: 'Christmas Elf', slug: 'christmas-elf', icon: '🎄', description: 'Cheerful, industrious, and festive.' },
  { name: 'Half-Elf', slug: 'half-elf', icon: '🧬', description: 'Versatile, resilient, and charming.' },
]

export function RaceCards() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
      {races.map((r) => (
        <Link key={r.name} to={`/names/${r.slug}`} className="block group">
          <Card className="h-full hover:bg-accent/50 transition-all cursor-pointer border-primary/20">
            <CardContent className="p-6">
              <div className="flex items-center gap-4">
                <div className="text-4xl bg-primary/10 w-16 h-16 flex items-center justify-center rounded-2xl group-hover:scale-110 transition-transform">
                  {r.icon}
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-bold">{r.name}</h3>
                  <p className="text-sm text-muted-foreground">{r.description}</p>
                </div>
                <ChevronRight className="h-5 w-5 opacity-30 group-hover:opacity-100 group-hover:translate-x-1 transition-all" />
              </div>
            </CardContent>
          </Card>
        </Link>
      ))}
    </div>
  )
}
